import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const e=l`
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <rect
            width="24"
            height="24"
            rx="12"
            fill="white" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 11.4666C3 7.34285 6.55541 4 10.941 4C15.3269 4 18.8824 7.34285 18.8824 11.4666C18.8824 15.5903 15.3269 18.9333 10.941 18.9333C6.55541 18.9333 3 15.5903 3 11.4666Z"
            fill="#FFFFFE" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.3793 11.9861C15.3762 10.0082 14.174 8.32123 12.4798 7.65318V16.3188C14.174 15.6499 15.3762 13.9645 15.3793 11.9861ZM9.24785 16.3171V7.65404C7.55517 8.32421 6.35471 10.0087 6.35023 11.9861C6.35471 13.9631 7.55517 15.6475 9.24785 16.3171ZM10.8647 4.66168C6.93102 4.66324 3.74412 7.94113 3.74347 11.9861C3.74412 16.0307 6.93102 19.308 10.8647 19.3087C14.7982 19.308 17.9859 16.0307 17.9868 11.9861C17.9859 7.94113 14.7982 4.66324 10.8647 4.66168ZM10.8472 19.9999C6.5428 20.021 3 16.4349 3 12.0697C3 7.29894 6.5428 3.99914 10.8472 4H12.8644C17.1179 3.99914 21 7.29739 21 12.0697C21 16.4334 17.1179 19.9999 12.8644 19.9999H10.8472Z"
            fill="#0069AA" />
    </svg>
`,n=i("diners_club",e),d=i("diners",e);export{d as Diners,n as DinersClub};
